import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";
import { planDailyBatches, validateSendWindow, type DisparoSendWindow } from "@/lib/disparos-window";

interface Props {
  enabled: boolean;
  onEnabledChange: (v: boolean) => void;
  value: DisparoSendWindow;
  onChange: (v: DisparoSendWindow) => void;
  recipientCount: number;
  delayMax: number;
  scheduledAt: string;
}

export function DisparoSendWindowFields({
  enabled,
  onEnabledChange,
  value,
  onChange,
  recipientCount,
  delayMax,
  scheduledAt,
}: Props) {
  const invalid = enabled ? validateSendWindow(value) : null;
  const batches =
    enabled && !invalid && recipientCount > 0
      ? planDailyBatches(Array.from({ length: recipientCount }), value, {
          delayMaxSeconds: delayMax,
          startAt: scheduledAt ? new Date(scheduledAt) : null,
        })
      : [];

  return (
    <div className="space-y-3 rounded-md border p-3 mt-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <Label htmlFor="send-window">Período de envio</Label>
          <p className="text-xs text-muted-foreground">
            Envia só dentro do horário escolhido. O que faltar continua no dia seguinte.
          </p>
        </div>
        <Switch id="send-window" checked={enabled} onCheckedChange={onEnabledChange} />
      </div>

      {enabled && (
        <>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1.5">
              <Label htmlFor="window-start">Das</Label>
              <Input
                id="window-start"
                type="time"
                value={value.start}
                onChange={(e) => onChange({ ...value, start: e.target.value })}
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="window-end">Até</Label>
              <Input
                id="window-end"
                type="time"
                value={value.end}
                onChange={(e) => onChange({ ...value, end: e.target.value })}
              />
            </div>
          </div>
          <label className="flex items-center gap-2 text-sm">
            <Checkbox
              checked={value.skip_weekends}
              onCheckedChange={(v) => onChange({ ...value, skip_weekends: v === true })}
            />
            Não enviar aos sábados e domingos
          </label>
          {invalid ? (
            <p className="text-xs text-destructive">{invalid}</p>
          ) : batches.length > 0 ? (
            <p className="text-xs text-muted-foreground">
              {batches.length === 1
                ? `Todos os ${recipientCount} contatos cabem em um dia.`
                : `Será dividido em ${batches.length} dias (cerca de ${batches[0].items.length} contatos no primeiro dia), calculado pelo intervalo máximo entre mensagens.`}
            </p>
          ) : null}
        </>
      )}
    </div>
  );
}
